import IconButton from '@mui/material/IconButton';
import { RedmineIcon } from 'framework/ui/mui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { copyByNavigator } from 'framework/ui/clipboard';
import LinkIconButtonEmployeeTeams from 'domain/people/employee/shared/button/LinkIconButtonEmployeeTeams';

interface LinkIconButtonsEmployeeDashboardProps {
  employeeEmailSource?: string;
  assigneeAliasSource?: string;
}

const LinkIconButtonsEmployeeDashboard = ({
  employeeEmailSource = 'employeeWorkingEmail',
  assigneeAliasSource = 'retentionRiskAssigneeAlias',
}: LinkIconButtonsEmployeeDashboardProps) => {
  const { getValue: getAssigneeAlias } = useFieldHelper({ source: assigneeAliasSource });
  const assignAlias = getAssigneeAlias();

  // TODO redmine ticket
  const handleRedmineButton = () => {
    copyByNavigator(assignAlias);
  };

  return (
    <>
      <LinkIconButtonEmployeeTeams employeeEmailSource={employeeEmailSource} />

      {false && (
        <IconButton
          onClick={handleRedmineButton}
          size="small"
          sx={{
            padding: '5px',
          }}
        >
          <RedmineIcon sx={{ fontSize: '13px' }} />
        </IconButton>
      )}
    </>
  );
};

export default LinkIconButtonsEmployeeDashboard;
